import { useEffect, useState } from 'react';
import { useNavermaps } from 'react-naver-maps';
import type { LatLng } from '@/shared/types';

const useTransTM128ToLantLng = (gisX?: number, gisY?: number) => {
	const navermaps = useNavermaps();
	const [location, setLocation] = useState<LatLng | null>(null);

	useEffect(() => {
		if (!navermaps.TransCoord || !gisX || !gisY) return;

		const { x, y } = navermaps.TransCoord.fromTM128ToLatLng(
			new naver.maps.Point(gisX, gisY),
		);
		setLocation({
			lat: y,
			lng: x,
		});
	}, [gisX, gisY, navermaps.TransCoord]);

	return location;
};

export default useTransTM128ToLantLng;
